import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const RegisterIdCardSearchPersonCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Ricerca Persona - Registrazione Carta Identità',
    path: '/sportello/registrazione-carta',
  },
];

export const RegisterIdCardCrumbs = [
  ...RegisterIdCardSearchPersonCrumbs,
  {
    name: 'Registrazione Carta Identità',
    path: '/sportello/registrazione-carta/registra',
  },
];
